import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import enLocale from './en_US'
import cnLocale from './zh_CN'
import hantLocale from './zh_Hant'
import locale from 'element-ui/lib/locale';
import en from 'element-ui/lib/locale/lang/en';
import zh from 'element-ui/lib/locale/lang/zh-CN';
import zh_hant from 'element-ui/lib/locale/lang/zh-TW';
//需要其它语种可以参考elementui官网地址
//https://element.eleme.cn/#/zh-CN/component/i18n

Vue.use(VueI18n);

const messages = {
  en_US: {
    ...enLocale,
    ...en
  },
  zh_CN: {
    ...cnLocale,
    ...zh
  },
  zh_Hant: {
    ...hantLocale,
    ...zh_hant
  }
}

const i18n = new VueI18n({
  // set locale
  // options: en_US | zh_CN
  locale: Cookies.get('language') || 'zh_CN',
  // set locale messages
  messages
})
locale.i18n((key, value) => i18n.t(key, value));
export default i18n
